<div class="content">
  <div class="small">
    <div class="grid">
      <div class="head">
        <ng-container [ngTemplateOutlet]="head"></ng-container>
      </div>
    </div>
  </div>

  <div class="medium">
    <div class="grid">
      <div class="head">
        <ng-container [ngTemplateOutlet]="head"></ng-container>
      </div>
      <div class="col1">
        <ng-container [ngTemplateOutlet]="col1"></ng-container>
      </div>
      <div class="col2">
        <ng-container [ngTemplateOutlet]="col2"></ng-container>
      </div>
    </div>
  </div>

  <div class="large">
    <div class="grid">
      <div class="head" >
        <ng-container [ngTemplateOutlet]="head"></ng-container>
      </div>
      <div class="col1">
        <ng-container [ngTemplateOutlet]="col1"></ng-container>
      </div>
      <div class="col2">
        <ng-container [ngTemplateOutlet]="col2"></ng-container>
      </div>
      <div class="col3">
        <ng-container [ngTemplateOutlet]="col3"></ng-container>
      </div>
    </div>
  </div>
</div>
